/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

import { Platform } from "react-native";

import { colors } from "./colors";

export const Colors = {
  dark: {
    background: colors.darkBackground,
    icon: colors.darkIcon,
    tabIconDefault: colors.darkIcon,
    tabIconSelected: colors.white,
    text: colors.darkText,
    tint: colors.white,
  },
  light: {
    background: colors.lightBackground,
    icon: colors.lightIcon,
    tabIconDefault: colors.lightIcon,
    tabIconSelected: colors.tint,
    text: colors.lightText,
    tint: colors.tint,
  },
};

export const Fonts = Platform.select({
  default: {
    mono: "monospace",
    rounded: "normal",
    sans: "normal",
    serif: "serif",
  },
  ios: {
    /** iOS `UIFontDescriptorSystemDesignMonospaced` */
    mono: "ui-monospace",
    /** iOS `UIFontDescriptorSystemDesignRounded` */
    rounded: "ui-rounded",
    /** iOS `UIFontDescriptorSystemDesignDefault` */
    sans: "system-ui",
    /** iOS `UIFontDescriptorSystemDesignSerif` */
    serif: "ui-serif",
  },
  web: {
    mono: "SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    rounded:
      "'SF Pro Rounded', 'Hiragino Maru Gothic ProN', Meiryo, 'MS PGothic', sans-serif",
    sans: "'Outfit', system-ui, -apple-system, sans-serif",
    serif: "Georgia, 'Times New Roman', serif",
  },
});
